import { render, staticRenderFns } from "./CarStatics.vue?vue&type=template&id=77505f46&scoped=true&"
import script from "./CarStatics.vue?vue&type=script&lang=js&"
export * from "./CarStatics.vue?vue&type=script&lang=js&"
import style0 from "./CarStatics.vue?vue&type=style&index=0&id=77505f46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77505f46",
  null
  
)

export default component.exports